module.exports = __webpack_public_path__ + "img/logo1.a2796b0b.png";